<template>
  <div class="ip-profile-details">
    <b-card>
      <b-row class="mb-2">
        <b-col sm="3" class="text-sm-right"><b>Name:</b></b-col>
        <b-col>{{ name }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="3" class="text-sm-right"><b>Prefix:</b></b-col>
        <b-col>{{ prefix }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="3" class="text-sm-right"><b>sip server:</b></b-col>
        <b-col>{{ sip_server }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="3" class="text-sm-right"><b>sip server port:</b></b-col>
        <b-col>{{ sip_server_port }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="3" class="text-sm-right"><b>sip server transport:</b></b-col>
        <b-col>{{ sip_server_transport }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="3" class="text-sm-right"><b>rtp proxy:</b></b-col>
        <b-col>{{ rtp_proxy }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="3" class="text-sm-right"><b>offer codecs:</b></b-col>
        <b-col
          ><b-badge
            v-for="codec in offer_codecs"
            :key="codec"
            variant="secondary"
            class="mr-2"
          >
            {{ codec }}
          </b-badge></b-col
        >
      </b-row>
      <b-row class="mb-2">
        <b-col sm="3" class="text-sm-right"><b>ips:</b></b-col>
        <b-col>
          <b-badge v-for="{ ip } in ips" :key="ip" variant="info" class="mr-2">
            {{ ip }}
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="3" class="text-sm-right"><b>created at:</b></b-col>
        <b-col>{{ new Date(created_at).toUTCString() }}</b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    prefix: String,
    sip_server: String,
    sip_server_port: String,
    sip_server_transport: String,
    rtp_proxy: String,
    offer_codecs: String,
    ips: Array,
    created_at: String,
  },
};
</script>
